import errorimg from "../../assets/error.svg";
import './index.scss'
export default function ErrorMsg({errorMsg}){
    if(!errorMsg) return;
    return <div className="Signin-errorCont">
    <img src={errorimg} alt="errorimg" />
    <p className="Signin-errorCont__text">{errorMsg}</p>
</div>
}